import { render, staticRenderFns } from "./EditColumn.vue?vue&type=template&id=7d236f05"
import script from "./EditColumn.vue?vue&type=script&lang=js"
export * from "./EditColumn.vue?vue&type=script&lang=js"
import style0 from "./EditColumn.vue?vue&type=style&index=0&id=7d236f05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports